// IMPORTS
// Modules
import { useEffect } from 'react';
// OHS
import OHSTiles from './../../onehivesystems/js/OHSTiles';
// Assets
import './GlobalDashboard.scss';
import NavigateApps from './Modules/NavigateApps';


// COMPONENT
export default function GlobalDashboard (props) {
   // On-Load
   useEffect(function () {
      props.onehive.setOneHiveTitle("Global Dashboard"); // set page title
   }, []);

   // Component
   return (
      <div className="globaldashboard">
         <OHSTiles onehive={props.onehive} content={[
            {
               title: "Navigate Apps",
               content: <NavigateApps onehive={props.onehive} />
         }]} />
      </div>
   );
}